export * from '../sculpt';

export enum SculptMeshCodec {
  None = 0,
  Json = 101,
  Draco = 102,
  Ply = 103,
  Stl = 104,
  Trans = 106,
}